import React, { createContext, useContext } from 'react'
import type { ActionFlowLayout, RunActionOptions, ActionOutcome, ActionFlowAction } from './types'

export type ActionFlowNavigate = (to: string) => void

export type ActionFlowRunAction = (
  action: ActionFlowAction,
  options?: RunActionOptions,
  e?: React.MouseEvent<HTMLButtonElement>
) => Promise<ActionOutcome>

export type ActionFlowContextType = {
  isOpen: boolean
  close: () => void
  navigate: ActionFlowNavigate
  goBack: () => void

  isPending: boolean
  isActionInProgress: boolean
  runAction: ActionFlowRunAction

  allowOverflow?: boolean
  modalLayout: ActionFlowLayout
  activeLayout?: ActionFlowLayout
  setActiveLayout: (layout?: ActionFlowLayout) => void
}

export const ActionFlowContext = createContext<ActionFlowContextType | undefined>(undefined)

export const useActionFlow = (): ActionFlowContextType => {
  const ctx = useContext(ActionFlowContext)
  if (!ctx) throw new Error('useActionFlow must be used within ActionFlow.Modal')
  return ctx
}

export const normalizeActionFlowPath = (path: string): string => {
  if (!path) return '/'
  return path.startsWith('/') ? path : `/${path}`
}

export const delay = (ms: number) => new Promise<void>(resolve => setTimeout(resolve, ms))
